export interface Project {
  id: string;
  index: string;
  title: string;
  tagline: string;
  description: string;
  tech: string[];
  flow: string[];
  features?: string[];
}

export const projects: Project[] = [
  {
    id: "ai-code-review",
    index: "01",
    title: "AI CODE REVIEW PLATFORM",
    tagline: "AI · .NET · AUTOMATION",
    description:
      "AI-assisted source-code analysis platform designed to identify issues, provide recommendations, and improve engineering workflows.",
    tech: ["C#", ".NET", "OpenAI", "RAG", "Vector DB", "GitHub", "SQL Server"],
    flow: ["CODE", "AI ANALYSIS", "ISSUES", "SUGGESTIONS", "FIX"],
    features: [
      "Code Review",
      "Review History",
      "Dashboard",
      "GitHub Integration",
      "PR Auto Review",
      "AI Suggestions",
      "Team Collaboration",
      "Code Quality Trends",
    ],
  },
  {
    id: "vision-inspection",
    index: "02",
    title: "VISION INSPECTION SYSTEM",
    tagline: "COMPUTER VISION · INDUSTRIAL",
    description:
      "Industrial software combining machine vision, inspection workflows, logging, configuration, and automated decision-making.",
    tech: ["C#", ".NET", "HALCON", "Computer Vision", "Industrial Automation", "SQL"],
    flow: ["CAMERA", "IMAGE", "INSPECTION", "RESULT"],
  },
  {
    id: "enterprise-printing",
    index: "03",
    title: "ENTERPRISE PRINTING & INSPECTION PLATFORM",
    tagline: "WINDOWS · COMPLIANCE",
    description:
      "A compliance-oriented Windows application combining printing, inspection, configuration, logging, hardware communication, and operational workflows.",
    tech: ["C#", ".NET", "WinForms", "HALCON", "SQL", "Hardware Integration", "Logging"],
    flow: ["CONFIGURATION", "PROCESS", "INSPECTION", "PRINT", "LOG"],
  },
];
